/******************************************************************************************
 *	Team Members Controller
 ******************************************************************************************/
(function() {


  angular.module('rcControllers.teamMembers', []).controller(
    'TeamMembersController',
    /* @ngInject */
    function(
      _,
      $scope,
      $translate,
      Languages,
      Settings,
      SspList,
      User,
      TeamMembers,
      TeamMemberStatus,
      AddTeamMembersModal,
      RemoveTeamMemberModal
    ) {
      //Expose TeamMemberStatus service to the $scope
      $scope.TeamMemberStatus = TeamMemberStatus;

      //Array containing all email addresses of team members.
      //Required by the invitation modal in order to check for duplicates
      //Cannot rely on $scope.teamMembers.data because searching removes items from list.
      var arMemberEmails = [];

      //Function that gets Team Members and parses data
      var getTeamMembers = function() {
        //Loading spinner on
        $scope.loadingData = true;

        TeamMembers.get()
          .then(function(responseData) {
            initTeamMembers(injectAdditionalData(responseData));

            //Save each member's email address
            arMemberEmails = _.map(responseData, 'email');

            //We have data
            $scope.noData = false;

            //Loading spinner off
            $scope.loadingData = false;

            //Check if invite modal was requested while data was loading and if so, open it
            checkIfInvitationModalWasRequested();
          })
          .catch(function(response) {
            if (response.status !== 0) {
              //status is 0 when call is aborted
              $scope.errorMessage = 'global.dataList.emptyMessages.noResultsFound';
              $scope.noData = true;

              //Loading spinner off
              $scope.loadingData = false;
            }
          });
      };

      var injectAdditionalData = function(data) {
        if (data) {
          _.forEach(data, function(item) {
            switch(item.status) {
              case 'ACTIVE':
                item.statusLabel = $translate.instant('teamMembers.statuses.active');
                break;
              case 'PENDING':
                item.statusLabel = $translate.instant('teamMembers.statuses.pending');
                break;
              default:
                item.statusLabel = '';
                break;
            }
          });
        }
        return data;
      };

      //Team Members Data List init and refresh
      var teamDataList;
      var refreshTeamMembers = function(options) {
        $scope.teamMembers = teamDataList.get(options);
        if (!$scope.teamMembers.data.length) {
          $scope.noSearchResults = true;
          $scope.errorMessage = 'global.dataList.emptyMessages.noResultsFound';
        } else {
          $scope.noSearchResults = false;
        }
      };
      var initTeamMembers = function(data) {
        teamDataList = new SspList(data, {
          itemsPerPage: Settings.itemsPerPage.default,
          searchFields: ['first_name', 'last_name', 'email', 'statusLabel'],
          fallbackSort: {column: 'first_name,last_name,email'},
          minSearchLength: Languages.minSearchLength()
        });

        refreshTeamMembers({page: 1, sortBy: 'status', sortDirection: 'desc'});
      };

      //Pagination
      $scope.goToPage = function(page) {
        refreshTeamMembers({page: page});
      };

      //Sorting
      $scope.sort = function(column, serverColumns, isNumeric) {
        refreshTeamMembers({sortBy: column, sortNumeric: isNumeric});
      };

      //Search
      $scope.search = function(query) {
        refreshTeamMembers({query: query});
      };
      $scope.clearSearch = function() {
        teamDataList.clearSearch();
        refreshTeamMembers();
      };

      //Initial call to get Team Members
      getTeamMembers();

      /*=== Add Team Members Modal ===*/

      //Controls the disable state of the invite button
      $scope.openInviteModalWhenReady = false;
      var checkIfInvitationModalWasRequested = function() {
        if ($scope.openInviteModalWhenReady) {
          $scope.openInviteModalWhenReady = false;
          $scope.showInviteModal();
        }
      };

      $scope.showInviteModal = function() {
        if (User.isResellerAdmin() || User.isLicenseAdminReadWrite()) {
          //If data isn't loaded yet, remember user intent and show modal when data is ready.
          //Must wait for data in order to give modal member data.
          if ($scope.loadingData) {
            $scope.openInviteModalWhenReady = true;
          } else {
            //Make member emails available to modal controller so it can invalidate duplicate emails
            var locals = {
              memberEmails: arMemberEmails
            };

            AddTeamMembersModal.create(locals).then(function(data) {
              if (data) {
                // If modal wasn't cancelled (closed without any successful submits), insert new
                // members into the list.
                var newMembers = [];

                // If true some invites have been sent, followed either by a cancel or a successful
                // re-try on corrected emails.
                if (data.partialCreated) {
                  Array.prototype.push.apply(newMembers, data.partialCreated);
                }

                // If cancelled no invites were just sent.
                if (!data.cancelled) {
                  Array.prototype.push.apply(newMembers, data.response.created);
                }

                // Update the team members shown.
                if (newMembers.length) {
                  var consolidatedMembers = teamDataList.getOriginalDataset();
                  _.forEach(newMembers, function(item) {
                    consolidatedMembers.push(item);
                    arMemberEmails.push(item.email);
                  });

                  initTeamMembers(injectAdditionalData(consolidatedMembers));
                }
              }
            });
          }
        }
      };

      /*=== Cancel Invitation Modal ===*/
      $scope.cancelInvitation = function(member) {
        if ((User.isResellerAdmin() || User.isLicenseAdminReadWrite()) && member.canBeDeleted) {
          var locals = {
            member: member
          };

          RemoveTeamMemberModal.create(locals).then(function(data) {
            if (data && !data.cancelled) {
              //Remove team member from list
              var exMember = data.response;
              if (exMember) {
                var allTeamMembers = teamDataList.getOriginalDataset();
                for (var i = 0, count = allTeamMembers.length; i < count; i++) {
                  //If exMember had a user Id, use that to find him or her in the collection.
                  //Otherwise, use the invite code.
                  var match =
                    (exMember.userId &&
                      allTeamMembers[i].userId &&
                      allTeamMembers[i].userId === exMember.userId) ||
                    (exMember.inviteCode &&
                      allTeamMembers[i].inviteCode &&
                      allTeamMembers[i].inviteCode === exMember.inviteCode);

                  if (match) {
                    allTeamMembers.splice(i, 1);
                    break;
                  }
                }
                initTeamMembers(injectAdditionalData(allTeamMembers));

                //Remove email from arMemberEmails
                var index = arMemberEmails.indexOf(exMember.email);
                if (index >= 0) {
                  arMemberEmails.splice(index, 1);
                }
              }
            }
          });
        }
      };

      /*=== Clean-up ===*/
      $scope.$on('$destroy', function() {
        //Remove any modals if visible, otherwise navigation (via back / forward arrows) would preserve the modal over other views
        AddTeamMembersModal.remove();
        RemoveTeamMemberModal.remove();
      });
    }
  );
})();
